import { createFileRoute, redirect } from '@tanstack/react-router';
import { AdminPage } from '@/pages/Admin';
import { useAuthStore } from '@/stores/authStore';

export const Route = createFileRoute('/admin')({
  beforeLoad: () => {
    const isAuthenticated = useAuthStore.getState().isAuthenticated;
    if (!isAuthenticated) {
      throw redirect({
        to: '/',
        search: { showLogin: true },
      });
    }
  },
  component: AdminPage,
});
